// 28/10/2026 lot 1 (audit technique) : accès au stockage protégés — en navigation privée / cookies refusés,
// localStorage et sessionStorage lèvent une exception qui tuait tout le script (chat, suivi, vitrine).
var bdpStore = window.bdpStore || (window.bdpStore = {
  get:  function(k)    { try { return localStorage.getItem(k); } catch (e) { return null; } },
  set:  function(k, v) { try { localStorage.setItem(k, v); return true; } catch (e) { return false; } },
  del:  function(k)    { try { localStorage.removeItem(k); } catch (e) {} },
  sget: function(k)    { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
  sset: function(k, v) { try { sessionStorage.setItem(k, v); return true; } catch (e) { return false; } },
  sdel: function(k)    { try { sessionStorage.removeItem(k); } catch (e) {} }
});

/**
 * Wishlist - Boutique du Plaisir
 * Script de gestion de la wishlist avec design élégant et professionnel
 * Version finale avec gestion complète des variantes et mise à jour automatique du panier
 */

document.addEventListener('DOMContentLoaded', function() {
  // Initialisation de l'objet wishlist
  window.wishlist = {
    items: [],
    isCustomerLoggedIn: false,
    
    // Initialisation de la wishlist
    init: function() {
      // Vérifier si le client est connecté (variable Shopify)
      this.checkCustomerStatus();
      
      // Vérifier s'il faut rediriger après connexion
      this.checkPostLoginRedirect();
      
      // Charger les produits de la wishlist depuis le localStorage
      this.loadWishlist();
      
      // Mettre à jour le compteur dans le header
      this.updateWishlistCount();
      
      // Ajouter les écouteurs d'événements aux boutons wishlist
      this.setupEventListeners();
    },
    
    // Vérifier et effectuer la redirection après connexion
    checkPostLoginRedirect: function() {
      const returnUrl = bdpStore.get('wishlist_return_url');
      
      if (returnUrl && this.isCustomerLoggedIn) {
        console.log('Wishlist: Redirection après connexion vers:', returnUrl);
        
        // Supprimer l'URL du localStorage
        bdpStore.del('wishlist_return_url');
        
        // Rediriger vers l'URL sauvegardée (avec un petit délai pour éviter les conflits)
        setTimeout(() => {
          window.location.href = returnUrl;
        }, 100);
        return;
      }
      
      if (returnUrl && !this.isCustomerLoggedIn) {
        console.log('Wishlist: URL de retour trouvée mais utilisateur non connecté');
      }
    },
    
    // Vérifier le statut de connexion du client
    checkCustomerStatus: function() {
      console.log('Wishlist: Début de la vérification du statut de connexion');
      
      // Méthode 1: Variable globale (la plus fiable)
      if (typeof window.isCustomerLoggedIn !== 'undefined') {
        this.isCustomerLoggedIn = window.isCustomerLoggedIn;
        console.log('Wishlist: Statut détecté via variable globale:', this.isCustomerLoggedIn);
        return;
      }
      
      // Méthode 2: Élément DOM global
      const globalCustomerData = document.querySelector('#global-customer-status');
      if (globalCustomerData) {
        const status = globalCustomerData.getAttribute('data-customer-logged-in');
        this.isCustomerLoggedIn = status === 'true';
        console.log('Wishlist: Statut détecté via élément DOM global:', status, '- Connecté:', this.isCustomerLoggedIn);
        return;
      }
      
      // Méthode 3: Élément DOM local (fallback)
      const localCustomerData = document.querySelector('[data-customer-logged-in]');
      if (localCustomerData) {
        const status = localCustomerData.getAttribute('data-customer-logged-in');
        this.isCustomerLoggedIn = status === 'true';
        console.log('Wishlist: Statut détecté via élément DOM local:', status, '- Connecté:', this.isCustomerLoggedIn);
        return;
      }
      
      // Méthode 4: Test API (dernière option)
      console.log('Wishlist: Aucune méthode de détection directe - Test API');
      this.testCustomerStatusViaAPI();
    },
    
    // Test du statut via API (méthode de fallback)
    testCustomerStatusViaAPI: function() {
      const self = this;
      fetch('/account')
        .then(response => {
          if (response.status === 200) {
            self.isCustomerLoggedIn = true;
            console.log('Wishlist: Statut confirmé via API - Connecté:', true);
          } else {
            self.isCustomerLoggedIn = false;
            console.log('Wishlist: Statut confirmé via API - Connecté:', false);
          }
        })
        .catch(error => {
          console.log('Wishlist: Erreur test API, assume non connecté:', error);
          self.isCustomerLoggedIn = false;
        });
    },
    
    // Vérifier si l'utilisateur peut utiliser la wishlist
    canUseWishlist: function() {
      console.log('Wishlist: Vérification d\'accès - Connecté:', this.isCustomerLoggedIn);
      if (!this.isCustomerLoggedIn) {
        console.log('Wishlist: Utilisateur non connecté - Affichage de la modal de connexion');
        this.showLoginPrompt();
        return false;
      }
      console.log('Wishlist: Utilisateur connecté - Accès autorisé');
      return true;
    },
    
    // Afficher une invite de connexion
    showLoginPrompt: function() {
      // Sauvegarder l'URL actuelle dans le localStorage pour la redirection après connexion
      const currentUrl = window.location.href;
      bdpStore.set('wishlist_return_url', currentUrl);
      
      console.log('Wishlist: URL sauvegardée dans localStorage:', currentUrl);
      
      // URLs de connexion et inscription simples (sans paramètres)
      const loginUrl = '/account/login';
      const registerUrl = '/account/register';
      
      console.log('Wishlist: URLs de redirection - Login:', loginUrl, 'Register:', registerUrl);
      
      // Créer une modal de connexion
      const modal = document.createElement('div');
      modal.className = 'wishlist-login-modal';
      modal.innerHTML = `
        <div class="wishlist-login-modal__backdrop"></div>
        <div class="wishlist-login-modal__content">
          <div class="wishlist-login-modal__header">
            <h3>Connexion requise</h3>
            <button class="wishlist-login-modal__close" aria-label="Fermer">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </div>
          <div class="wishlist-login-modal__body">
            <p>Vous devez être connecté pour utiliser la wishlist.</p>
            <div class="wishlist-login-modal__actions">
              <a href="${loginUrl}" class="wishlist-login-modal__button wishlist-login-modal__button--primary">Se connecter</a>
              <a href="${registerUrl}" class="wishlist-login-modal__button wishlist-login-modal__button--secondary">Créer un compte</a>
            </div>
          </div>
        </div>
      `;
      
      // Ajouter la modal au body
      document.body.appendChild(modal);
      
      // Afficher la modal avec animation
      setTimeout(() => {
        modal.classList.add('is-visible');
      }, 10);
      
      // Gérer la fermeture de la modal
      const closeModal = () => {
        modal.classList.remove('is-visible');
        setTimeout(() => {
          if (modal.parentNode) {
            document.body.removeChild(modal);
          }
        }, 300);
      };
      
      // Écouteurs pour fermer la modal
      modal.querySelector('.wishlist-login-modal__close').addEventListener('click', closeModal);
      modal.querySelector('.wishlist-login-modal__backdrop').addEventListener('click', closeModal);
      
      // Fermer avec Escape
      const handleKeydown = (e) => {
        if (e.key === 'Escape') {
          closeModal();
          document.removeEventListener('keydown', handleKeydown);
        }
      };
      document.addEventListener('keydown', handleKeydown);
    },
    
    // Charger les produits de la wishlist depuis le localStorage
    loadWishlist: function() {
      const savedWishlist = bdpStore.get('wishlist');
      if (savedWishlist) {
        try {
          this.items = JSON.parse(savedWishlist);
        } catch (e) {
          console.error('Erreur lors du chargement de la wishlist:', e);
          this.items = [];
        }
      }
    },
    
    // Sauvegarder la wishlist dans le localStorage
    saveWishlist: function() {
      bdpStore.set('wishlist', JSON.stringify(this.items));
    },
    
    // Ajouter un produit à la wishlist
    addToWishlist: function(productId, productTitle, productImage, productUrl, productPrice, productHandle) {
      // Vérifier si l'utilisateur peut utiliser la wishlist
      if (!this.canUseWishlist()) {
        return false;
      }
      
      // Vérifier si le produit est déjà dans la wishlist
      if (!this.isInWishlist(productId)) {
        // Ajouter le produit à la wishlist
        this.items.push({
          id: productId,
          title: productTitle,
          image: productImage,
          url: productUrl,
          price: productPrice,
          handle: productHandle
        });
        
        // Sauvegarder la wishlist
        this.saveWishlist();
        
        // Mettre à jour le compteur
        this.updateWishlistCount();
        
        // Afficher une notification
        this.showToast('Produit ajouté à votre wishlist');
        
        return true;
      }
      
      return false;
    },
    
    // Retirer un produit de la wishlist
    removeFromWishlist: function(productId) {
      // Vérifier si le produit est dans la wishlist
      if (this.isInWishlist(productId)) {
        // Retirer le produit de la wishlist
        this.items = this.items.filter(item => item.id !== productId);
        
        // Sauvegarder la wishlist
        this.saveWishlist();
        
        // Mettre à jour le compteur
        this.updateWishlistCount();
        
        // Afficher une notification
        this.showToast('Produit retiré de votre wishlist');
        
        return true;
      }
      
      return false;
    },
    
    // Vérifier si un produit est dans la wishlist
    isInWishlist: function(productId) {
      return this.items.some(item => item.id === productId);
    },
    
    // Ajouter un produit au panier avec gestion des variantes
    addToCart: function(productHandle, productId) {
      // Créer le loader
      const loader = this.createLoader();
      document.body.appendChild(loader);
      
      // Récupérer les informations du produit avec ses variantes
      fetch(`/products/${productHandle}.js`)
        .then(response => response.json())
        .then(product => {
          // Supprimer le loader
          if (document.body.contains(loader)) {
            document.body.removeChild(loader);
          }
          
          if (product.variants && product.variants.length > 0) {
            // Si le produit a plusieurs variantes, afficher le sélecteur
            if (product.variants.length > 1) {
              this.showVariantSelector(product, productId);
            } else {
              // Si une seule variante, l'ajouter directement
              const variant = product.variants[0];
              if (variant.available) {
                // Utiliser le nom du produit si la variante s'appelle "Default Title"
                const displayName = variant.title === 'Default Title' ? product.title : variant.title;
                this.addVariantToCart(variant.id, displayName, product.title);
              } else {
                this.showToast('Ce produit n\'est pas disponible', 'error');
              }
            }
          } else {
            this.showToast('Produit non disponible', 'error');
          }
        })
        .catch(error => {
          // Supprimer le loader
          if (document.body.contains(loader)) {
            document.body.removeChild(loader);
          }
          console.error('Erreur lors de la récupération du produit:', error);
          this.showToast('Erreur lors de la récupération du produit', 'error');
        });
    },
    
    // Afficher le sélecteur de variantes
    showVariantSelector: function(product, productId) {
      // Créer la modal de sélection
      const modal = document.createElement('div');
      modal.className = 'wishlist-variant-modal';
      
      // Construire les options de variantes
      let variantOptions = '';
      product.variants.forEach(variant => {
        if (variant.available) {
          const price = (variant.price / 100).toFixed(2).replace('.', ',');
          variantOptions += `
            <div class="wishlist-variant-option" data-variant-id="${variant.id}">
              <div class="wishlist-variant-option__info">
                <div class="wishlist-variant-option__title">${variant.title}</div>
                <div class="wishlist-variant-option__price">${price} €</div>
              </div>
              <button class="wishlist-variant-option__select" data-variant-id="${variant.id}" data-variant-title="${variant.title}">
                Choisir
              </button>
            </div>
          `;
        }
      });
      
      modal.innerHTML = `
        <div class="wishlist-variant-modal__backdrop"></div>
        <div class="wishlist-variant-modal__content">
          <div class="wishlist-variant-modal__header">
            <h3>Choisir une variante</h3>
            <button class="wishlist-variant-modal__close" aria-label="Fermer">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </div>
          <div class="wishlist-variant-modal__body">
            <div class="wishlist-variant-modal__product">
              <img src="${product.featured_image}" alt="${product.title}" class="wishlist-variant-modal__image">
              <h4 class="wishlist-variant-modal__title">${product.title}</h4>
            </div>
            <div class="wishlist-variant-modal__options">
              ${variantOptions}
            </div>
          </div>
        </div>
      `;
      
      // Ajouter la modal au body
      document.body.appendChild(modal);
      
      // Afficher la modal avec animation
      setTimeout(() => {
        modal.classList.add('is-visible');
      }, 10);
      
      // Gérer la fermeture de la modal
      const closeModal = () => {
        modal.classList.remove('is-visible');
        setTimeout(() => {
          if (modal.parentNode) {
            document.body.removeChild(modal);
          }
        }, 300);
      };
      
      // Écouteurs pour fermer la modal
      modal.querySelector('.wishlist-variant-modal__close').addEventListener('click', closeModal);
      modal.querySelector('.wishlist-variant-modal__backdrop').addEventListener('click', closeModal);
      
      // Écouteurs pour les boutons de sélection
      modal.querySelectorAll('.wishlist-variant-option__select').forEach(button => {
        button.addEventListener('click', (e) => {
          const variantId = e.target.getAttribute('data-variant-id');
          const variantTitle = e.target.getAttribute('data-variant-title');
          
          closeModal();
          // Utiliser le nom du produit si la variante s'appelle "Default Title"
          const displayName = variantTitle === 'Default Title' ? product.title : variantTitle;
          this.addVariantToCart(variantId, displayName, product.title);
        });
      });
      
      // Fermer avec Escape
      const handleKeydown = (e) => {
        if (e.key === 'Escape') {
          closeModal();
          document.removeEventListener('keydown', handleKeydown);
        }
      };
      document.addEventListener('keydown', handleKeydown);
    },
    
    // Ajouter une variante spécifique au panier (MÉTHODE MISE À JOUR)
    addVariantToCart: function(variantId, variantTitle, productTitle = null) {
      // Créer le loader
      const loader = this.createLoader();
      document.body.appendChild(loader);
      
      // Déclencher l'événement de début de chargement (comme dans le thème)
      document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));
      
      // Préparer les sections à mettre à jour (exactement comme dans le thème)
      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { 
        bubbles: true, 
        detail: { sections: sectionsToBundle } 
      }));
      
      // Préparer les données à envoyer (exactement comme dans le thème)
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', 1);
      formData.append('sections', sectionsToBundle.join(','));
      formData.append('sections_url', `${Shopify.routes.root}variants/${variantId}`);
      
      // Faire la requête AJAX pour ajouter au panier (exactement comme dans le thème)
      fetch(`${Shopify.routes.root}cart/add.js`, {
        body: formData,
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      .then(response => response.json())
      .then(async (responseJson) => {
        // Déclencher l'événement de fin de chargement
        document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
        
        // Supprimer le loader
        if (document.body.contains(loader)) {
          document.body.removeChild(loader);
        }
        
        if (responseJson.status && responseJson.status !== 200) {
          // Gérer les erreurs (produit non disponible, etc.)
          this.showToast(responseJson.description || 'Erreur lors de l\'ajout au panier', 'error');
          return;
        }
        
        // Récupérer le contenu complet du panier (exactement comme dans le thème)
        const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
        
        // Gestion du type de panier selon les paramètres du thème
        if (window.themeVariables && window.themeVariables.settings) {
          if (window.themeVariables.settings.cartType === "page" || window.themeVariables.settings.pageType === "cart") {
            // Rediriger vers la page panier
            window.location.href = `${Shopify.routes.root}cart`;
            return;
          }
        }
        
        // Ajouter les sections à la réponse du panier
        cartContent['sections'] = responseJson['sections'];
        
        // Déclencher l'événement variant:add EXACTEMENT comme dans le thème
        const formElement = document.querySelector('form') || document.createElement('form');
        formElement.dispatchEvent(new CustomEvent("variant:add", {
          bubbles: true,
          detail: {
            items: responseJson.hasOwnProperty("items") ? responseJson["items"] : [responseJson],
            cart: cartContent,
            onSuccessDo: "force_open_drawer" // Force l'ouverture du drawer
          }
        }));
        
        // Déclencher l'événement cart:change EXACTEMENT comme dans le thème
        document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
          bubbles: true,
          detail: {
            baseEvent: "variant:add",
            onSuccessDo: "force_open_drawer",
            cart: cartContent
          }
        }));
        
        // Afficher une notification de succès
        // Utiliser le nom du produit si pas de titre de variante spécifique ou si c'est "Default Title"
        const displayName = (!variantTitle || variantTitle === 'Default Title') ? 
          (productTitle || 'Produit') : variantTitle;
        this.showToast(`${displayName} ajouté au panier !`);
        
        console.log('Variante ajoutée au panier avec mise à jour automatique:', responseJson);
      })
      .catch(error => {
        // Déclencher l'événement de fin de chargement
        document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
        
        // Supprimer le loader
        if (document.body.contains(loader)) {
          document.body.removeChild(loader);
        }
        
        console.error('Erreur lors de l\'ajout au panier:', error);
        this.showToast('Erreur lors de l\'ajout au panier', 'error');
      });
    },
    
    // Créer un loader pour les actions
    createLoader: function() {
      const loader = document.createElement('div');
      loader.className = 'wishlist-loader';
      loader.innerHTML = `
        <div class="wishlist-loader__backdrop"></div>
        <div class="wishlist-loader__spinner">
          <svg width="40" height="40" viewBox="0 0 50 50">
            <circle cx="25" cy="25" r="20" fill="none" stroke="rgb(200, 0, 62)" stroke-width="4" stroke-linecap="round" stroke-dasharray="31.416" stroke-dashoffset="31.416">
              <animate attributeName="stroke-dasharray" dur="2s" values="0 31.416;15.708 15.708;0 31.416" repeatCount="indefinite"/>
              <animate attributeName="stroke-dashoffset" dur="2s" values="0;-15.708;-31.416" repeatCount="indefinite"/>
            </animate>
          </circle>
        </svg>
      </div>
      `;
      return loader;
    },
    
    // Mettre à jour le compteur de produits dans le header
    updateWishlistCount: function() {
      const wishlistCount = document.querySelector('.wishlist-count');
      if (wishlistCount) {
        wishlistCount.textContent = this.items.length;
        
        if (this.items.length > 0) {
          wishlistCount.classList.add('is-visible');
        } else {
          wishlistCount.classList.remove('is-visible');
        }
      }
    },
    
    // Afficher une notification toast
    showToast: function(message, type = 'success') {
      // Supprimer les toasts existants
      const existingToasts = document.querySelectorAll('.wishlist-toast');
      existingToasts.forEach(toast => {
        if (toast.parentNode) {
          document.body.removeChild(toast);
        }
      });
      
      // Créer un nouvel élément toast
      const toast = document.createElement('div');
      toast.className = `wishlist-toast wishlist-toast--${type}`;
      
      // Choisir l'icône selon le type
      const icon = type === 'error' ? '⚠️' : type === 'success' ? '✅' : '❤️';
      
      // Ajouter l'icône et le message
      toast.innerHTML = `
        <span class="wishlist-toast__icon">${icon}</span>
        <span class="wishlist-toast__message">${message}</span>
      `;
      
      // Ajouter le toast au body
      document.body.appendChild(toast);
      
      // Afficher le toast avec une animation
      setTimeout(() => {
        toast.classList.add('is-visible');
      }, 10);
      
      // Masquer et supprimer le toast après 3 secondes
      setTimeout(() => {
        toast.classList.remove('is-visible');
        
        // Supprimer le toast après la fin de l'animation
        setTimeout(() => {
          if (toast.parentNode) {
            document.body.removeChild(toast);
          }
        }, 300);
      }, 3000);
    },
    
    // Basculer un produit dans la wishlist (ajouter ou retirer)
    toggleWishlist: function(button) {
      // Vérifier si l'utilisateur peut utiliser la wishlist
      if (!this.canUseWishlist()) {
        return false;
      }
      
      // Récupérer les informations du produit
      const productId = button.getAttribute('data-product-id');
      const productTitle = button.getAttribute('data-product-title');
      const productImage = button.getAttribute('data-product-image');
      const productUrl = button.getAttribute('data-product-url');
      const productPrice = button.getAttribute('data-product-price');
      const productHandle = button.getAttribute('data-product-handle');
      
      // Vérifier si le produit est déjà dans la wishlist
      if (this.isInWishlist(productId)) {
        // Retirer le produit de la wishlist
        this.removeFromWishlist(productId);
        
        // Mettre à jour l'apparence du bouton
        button.setAttribute('data-in-wishlist', 'false');
        const buttonText = button.querySelector('.wishlist-button__text');
        if (buttonText) {
          buttonText.textContent = 'Ajouter à la wishlist';
        }
      } else {
        // Ajouter le produit à la wishlist
        this.addToWishlist(productId, productTitle, productImage, productUrl, productPrice, productHandle);
        
        // Mettre à jour l'apparence du bouton
        button.setAttribute('data-in-wishlist', 'true');
        const buttonText = button.querySelector('.wishlist-button__text');
        if (buttonText) {
          buttonText.textContent = 'Retirer de la wishlist';
        }
      }
      
      // Mettre à jour tous les boutons avec le même productId
      this.updateAllButtonsForProduct(productId);
    },
    
    // Mettre à jour tous les boutons pour un produit spécifique
    updateAllButtonsForProduct: function(productId) {
      const allButtons = document.querySelectorAll(`[data-product-id="${productId}"]`);
      const isInWishlist = this.isInWishlist(productId);
      
      allButtons.forEach(button => {
        button.setAttribute('data-in-wishlist', isInWishlist ? 'true' : 'false');
        const buttonText = button.querySelector('.wishlist-button__text');
        if (buttonText) {
          buttonText.textContent = isInWishlist ? 'Retirer de la wishlist' : 'Ajouter à la wishlist';
        }
      });
    },
    
    // Configurer les écouteurs d'événements
    setupEventListeners: function() {
      // Sélectionner tous les boutons wishlist
      const wishlistButtons = document.querySelectorAll('[data-wishlist-button]');
      
      // Ajouter un écouteur d'événement à chaque bouton
      wishlistButtons.forEach(button => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          
          this.toggleWishlist(button);
        });
        
        // Mettre à jour l'état initial du bouton
        const productId = button.getAttribute('data-product-id');
        if (this.isInWishlist(productId)) {
          button.setAttribute('data-in-wishlist', 'true');
          const buttonText = button.querySelector('.wishlist-button__text');
          if (buttonText) {
            buttonText.textContent = 'Retirer de la wishlist';
          }
        } else {
          button.setAttribute('data-in-wishlist', 'false');
          const buttonText = button.querySelector('.wishlist-button__text');
          if (buttonText) {
            buttonText.textContent = 'Ajouter à la wishlist';
          }
        }
      });
    },
    
    // Rendre la page wishlist
    renderWishlistPage: function() {
      const container = document.querySelector('.wishlist-page__container');
      const emptyState = document.querySelector('.wishlist-page__empty');
      
      if (!container || !emptyState) return;
      
      // Vider le conteneur
      container.innerHTML = '';
      
      // Vérifier si la wishlist est vide
      if (this.items.length === 0) {
        // Afficher l'état vide
        emptyState.style.display = 'block';
        container.style.display = 'none';
        return;
      }
      
      // Masquer l'état vide
      emptyState.style.display = 'none';
      container.style.display = 'grid';
      
      // Rendre chaque produit
      this.items.forEach(item => {
        const productCard = document.createElement('div');
        productCard.className = 'wishlist-product-card';
        productCard.setAttribute('data-product-id', item.id);
        
        productCard.innerHTML = `
          <div class="wishlist-product-card__image-container">
            <img src="${item.image}" alt="${item.title}" class="wishlist-product-card__image">
            <button class="wishlist-product-card__remove" aria-label="Retirer de la wishlist" data-remove-wishlist="${item.id}">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </div>
          <div class="wishlist-product-card__info">
            <a href="${item.url}" class="wishlist-product-card__title">${item.title}</a>
            <div class="wishlist-product-card__price">${item.price}</div>
            <div class="wishlist-product-card__actions">
              <button class="wishlist-product-card__add-to-cart" data-product-id="${item.id}" data-product-handle="${item.handle}">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3 3h2l.4 2M7 13h10l4-8H5.4m2.6 8L6 6H3m4 7v6a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-6m-7 3h2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                AJOUTER AU PANIER
              </button>
              <a href="${item.url}" class="wishlist-product-card__view-product">VOIR LE PRODUIT</a>
            </div>
          </div>
        `;
        
        // Ajouter la carte produit au conteneur
        container.appendChild(productCard);
        
        // Ajouter un écouteur d'événement au bouton de suppression
        const removeButton = productCard.querySelector(`[data-remove-wishlist="${item.id}"]`);
        if (removeButton) {
          removeButton.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            
            // Retirer le produit de la wishlist
            this.removeFromWishlist(item.id);
            
            // Mettre à jour tous les boutons pour ce produit
            this.updateAllButtonsForProduct(item.id);
            
            // Supprimer la carte produit avec une animation
            productCard.style.opacity = '0';
            productCard.style.transform = 'translateY(-10px)';
            
            setTimeout(() => {
              // Supprimer la carte produit
              if (productCard.parentNode) {
                container.removeChild(productCard);
              }
              
              // Vérifier si la wishlist est vide
              if (this.items.length === 0) {
                // Afficher l'état vide
                emptyState.style.display = 'block';
                container.style.display = 'none';
              }
            }, 300);
          });
        }
        
        // Ajouter un écouteur d'événement au bouton "Ajouter au panier"
        const addToCartButton = productCard.querySelector('.wishlist-product-card__add-to-cart');
        if (addToCartButton) {
          addToCartButton.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            
            const productId = addToCartButton.getAttribute('data-product-id');
            const productHandle = addToCartButton.getAttribute('data-product-handle');
            
            // Ajouter au panier avec gestion des variantes
            this.addToCart(productHandle, productId);
          });
        }
      });
    }
  };
  
  // Initialiser la wishlist
  window.wishlist.init();
  
  // Exposer la méthode renderWishlistPage globalement pour les pages wishlist
  if (window.location.pathname.includes('/pages/wishlist') || window.location.pathname.includes('/pages/ma-wishlist')) {
    // Attendre que le DOM soit complètement chargé
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        setTimeout(() => window.wishlist.renderWishlistPage(), 100);
      });
    } else {
      setTimeout(() => window.wishlist.renderWishlistPage(), 100);
    }
  }
});